import { Outlet, useLocation, ScrollRestoration } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';
import Header from './components/Header';
import Footer from './components/Footer';
import { useUserSync } from './lib/hooks';
import { ComparisonProvider } from './components/ComparisonContext';
import { CacheProvider } from './components/CacheContext';

function App() {
  const { isLoaded } = useUser();
  const location = useLocation();
  const isHome = location.pathname === '/';

  // Sync user data between Clerk and our database
  useUserSync();

  // Show loading state while Clerk is initializing
  if (!isLoaded) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-slate-950 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600 dark:text-gray-300">Cargando aplicación...</p>
        </div>
      </div>
    );
  }

  return (
    <CacheProvider>
      <ComparisonProvider>
        <div className={`min-h-screen ${isHome ? 'bg-white' : 'bg-gray-50 dark:bg-slate-950'}`}>
          <Header />
          <main className={`${isHome ? '' : 'pt-24'}`}>
            <Outlet />
          </main>
          <Footer />
          <ScrollRestoration />
        </div>
      </ComparisonProvider>
    </CacheProvider>
  );
}

export default App;
